"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LLC_BUSINESS_OWNERSHIP_TYPES = exports.SelfAttestedBusinessOwnershipType = exports.IntendedTitleVesting = exports.OwnershipType = exports.NOO_RESIDENCE_TYPES = exports.ResidenceType = void 0;
/** @TranslateToPython @TranslateToRust */
var ResidenceType;
(function (ResidenceType) {
    ResidenceType["PRIMARY"] = "PRIMARY";
    ResidenceType["SECONDARY"] = "SECONDARY";
    ResidenceType["INVESTMENT"] = "INVESTMENT";
})(ResidenceType || (exports.ResidenceType = ResidenceType = {}));
// Temporary solution to avoid python requiring it's own isNoo implementation, enforce this with unit tests for now
/** @TranslateToPython */
exports.NOO_RESIDENCE_TYPES = [ResidenceType.SECONDARY, ResidenceType.INVESTMENT];
/** @TranslateToPython @TranslateToRust */
var OwnershipType;
(function (OwnershipType) {
    OwnershipType["INDIVIDUAL"] = "INDIVIDUAL";
    OwnershipType["JOINT"] = "JOINT";
    OwnershipType["TRUST"] = "TRUST";
    OwnershipType["BUSINESS"] = "BUSINESS";
})(OwnershipType || (exports.OwnershipType = OwnershipType = {}));
// The borrower's self-reported, forward-looking answer to "how do you plan to hold title?". This is a
// provisional preference collected during origination, not the confirmed vesting — actual title vesting is
// verified before closing and lives on the derived Home.vestingOwnershipRight / vestingOwnerType fields.
/** @TranslateToPython */
var IntendedTitleVesting;
(function (IntendedTitleVesting) {
    IntendedTitleVesting["individual"] = "individual";
    IntendedTitleVesting["jointly"] = "jointly";
    IntendedTitleVesting["trust"] = "trust";
})(IntendedTitleVesting || (exports.IntendedTitleVesting = IntendedTitleVesting = {}));
/** @TranslateToPython */
var SelfAttestedBusinessOwnershipType;
(function (SelfAttestedBusinessOwnershipType) {
    SelfAttestedBusinessOwnershipType["singleMemberLlc"] = "singleMemberLlc";
    SelfAttestedBusinessOwnershipType["multiMemberLlc"] = "multiMemberLlc";
    SelfAttestedBusinessOwnershipType["otherBusinessEntity"] = "otherBusinessEntity";
})(SelfAttestedBusinessOwnershipType || (exports.SelfAttestedBusinessOwnershipType = SelfAttestedBusinessOwnershipType = {}));
/** @TranslateToPython */
exports.LLC_BUSINESS_OWNERSHIP_TYPES = [SelfAttestedBusinessOwnershipType.singleMemberLlc, SelfAttestedBusinessOwnershipType.multiMemberLlc];
